export default "__VITE_ASSET__2c54b2b4__"